import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useCheckoutStore = defineStore('checkout', () => {
  const selections = ref(null);
  const hostTicketSelection = ref(null);

  const setSelections = (newSelections, ticketToBeFilled) => {
    selections.value = newSelections;
    hostTicketSelection.value = ticketToBeFilled;
  };

  const registrationResponse = ref(null);

  const setRegistrationResponse = (response) => {
    registrationResponse.value = response;
  };

  return {
    selections,
    setSelections,
    hostTicketSelection,
    setRegistrationResponse,
    registrationResponse,
  };
});
